<template>
  <div class="nav-list-wrapper">
    <ul role="tablist"
        v-if="!isMobile"
        class="list-group list-group-flush">
        <slot :item="item" v-for="(item, index) in items">
          <section-separator v-if="!item.hide && item.type && item.type === 'group'"
                             class="group-separator mt-2 mb-1 ml-2"
                             :class="{'mt-6': index > 0}"
          >
            {{item.name}}
          </section-separator>
          <template v-if="!item.hide && !item.type">
            <router-link v-if="item.routeName"
                         :style="item.style"
                         class="nav-list__item cursor-pointer d-flex justify-content-between"
                         :class="{'route-active': item.routeName === $route.name}"
                         :to="{ name: item.routeName, query: item.query }"
                         v-slot="{href}">
              <a :href="href">
                <template v-if="!item.rightValue">
                  {{item.name}}
                </template>
                <div v-else class="d-flex justify-content-between details__link">
                  <div>
                    {{item.name}}
                  </div>
                  <div>
                    {{item.rightValue}}
                  </div>
                </div>
              </a>
            </router-link>
            <a v-else href="#"
               class="nav-list__item no-link"
               :class="item.classes"
               @click.prevent="onExtraItemClick(item)">
              <i v-if="item.icon" class="mr-1 h5 mb-0" :class="item.icon"></i>
              <span>
                {{item.name}}
              </span>
            </a>
          </template>
        </slot>
    </ul>
    <div v-else>
      <h5>{{navTitle}}</h5>
      <el-select class="select-warning nav-select"
                 @change="onChange"
                 :value="$route.name">
        <el-option v-for="item in items"
                   v-if="!item.hide"
                   class="select-warning"
                   :key="item.name"
                   :value="item.routeName"
                   :label="item.name">
        </el-option>

      </el-select>
    </div>
  </div>
</template>

<script>
  import { Select, Option } from 'element-ui'
  import { mapGetters } from 'vuex';

  export default {
    name: 'nav-list',
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      type: {
        type: String,
        default: 'default'
      },
      vertical: {
        type: Boolean,
        default: true
      },
      items: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters('utils', ['isMobile']),
      navTitle() {
        return this.title || this.$t('generic.navigate');
      }
    },
    methods: {
      onChange(name) {
        this.$router.push({ name })
      },
      onExtraItemClick(item) {
        let name = item.title || item.name
        this.$emit(`on-${name}-click`.toLowerCase())
      }
    }
  }
</script>

<style lang="scss">
  .nav-list-wrapper {
    .nav-select.el-select {
      width: 100%;
    }
  }

  .settings-content {
    display: flex;
    justify-content: space-between;
  }

  a.nav-list__item {
    @apply text-gray-700 bg-transparent border border-transparent flex items-center;
    height: 36px;
    padding: 0 8px;
    &.no-link:hover,
    &:hover {
      @apply text-gray-700;
    }
  }
  .details__link {
    width: 100%;
  }
  .list-group .group-separator:first-child {
    margin-top: 0;
  }
  a.nav-list__item.group-separator {
    padding-left: 8px;
  }
  a.nav-list__item.active,
  a.nav-list__item.route-active{
    @apply bg-gray-200 font-bold rounded text-gray-900;
  }
</style>
